/**
 * @file app/constants/video.js
 */

export const VIDEO_CANONICAL_URL_BASE = "https://www.cbc.ca/player/play/";

export const VIDEO_CANONICAL_BASE_PATH = "/player/play/";

export const SYNDICATION_PLAYER_URL_BASE =
    "https://www.cbc.ca/i/phoenix/player/syndicate/?autoPlay=true&sourceId=";
